/**
 * @generated SignedSource<<d12373fe44f03c047fb946effe7b71ff>>
 * @relayHash 830a888b1d23fe6b09c569d2a279218b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6449b2cf6b4b29bdb6fc688e7633c0817f179f86cc2a6fc41e9f8cc023eb78ec

import type { ConcreteRequest, Query } from 'relay-runtime';
export type MoveInSidebarMenuItemQuery$variables = {
  cloudId: string;
};
export type MoveInSidebarMenuItemQuery$data = {
  readonly jira_projectsSidebarMenu: {
    readonly favourites: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly projectId: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
  };
};
export type MoveInSidebarMenuItemQuery = {
  response: MoveInSidebarMenuItemQuery$data;
  variables: MoveInSidebarMenuItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoveInSidebarMenuItemQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "JiraProjectsSidebarMenu",
          "kind": "LinkedField",
          "name": "jira_projectsSidebarMenu",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v4/*: any*/)
                ],
                "storageKey": "favourites(first:15)"
              },
              "action": "THROW",
              "path": "jira_projectsSidebarMenu.favourites"
            }
          ]
        },
        "action": "THROW",
        "path": "jira_projectsSidebarMenu"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoveInSidebarMenuItemQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v4/*: any*/)
            ],
            "storageKey": "favourites(first:15)"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "6449b2cf6b4b29bdb6fc688e7633c0817f179f86cc2a6fc41e9f8cc023eb78ec",
    "metadata": {},
    "name": "MoveInSidebarMenuItemQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f500c4030d06cf273b1bc3d6fe104ae3";

export default node;
